
import Vue from 'vue';
import { mask } from 'vue-the-mask';
import Tooltip from '@/components/Tooltip/index.vue';
import {
  StyledInput,
  StyledLabel,
  StyledLabelError,
  Icon,
  Type,
  WrapperIcon,
  WrapperInput,
} from './styles';

export default Vue.extend({
  name: 'Input',
  components: {
    StyledInput,
    StyledLabel,
    StyledLabelError,
    Tooltip,
    WrapperIcon,
    WrapperInput,
  },
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: String,
    icon: {
      type: String,
      default: '',
      validator(value: typeof Icon[number]) {
        return Icon.indexOf(value) !== -1;
      },
    },
    label: {
      type: String,
      default: '',
    },
    mask: {
      type: Array,
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    primary: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator(value: typeof Type[number]) {
        return Type.indexOf(value) !== -1;
      },
    },
    value: String,
  },
  directives: {
    mask: {
      bind(el, binding, vnode, oldVnode) {
        if (binding.value) mask(el, binding, vnode, oldVnode);
      },
    },
  },
  data() {
    return {
      iconColors: {
        eye: 'gray',
        search: 'white',
      },
      iconName: this.icon.toLowerCase(),
      inputType: this.type,
    };
  },
  methods: {
    changePassordInputVisibility() {
      this.inputType = this.inputType === 'text' ? 'password' : 'text';
    },
  },
});
